import { configureStore } from '@reduxjs/toolkit';
import unauthenticated from '../reducers/unauthenticated';

export const store = configureStore({
    reducer: {
        unauthenticated,
    },
});

